
import { Button, Col, Select, Tabs } from "antd";
import DpdBucket from "./Component/DpdBucket";
import FirstvsRepeat from "./Component/FirstvsRepeat";
import GenderAnalytics from "./Component/GenderAnalysis";
import PricipalPaid from "./Component/PrincipalPaid";
import QuartileBucket from "./Component/Quartile";
import { UploadOutlined } from "@ant-design/icons";
const Data = require("./mock.json");

const DailyIntervention = () => {


   const items = [
    {
      label: "DPD Bucket",
      key: "1",
      children: <DpdBucket data={Data?.data?.dpdBuckets} />,
    },
    {
      label: "Principal Paid",
      key: "2",
      children: <PricipalPaid data={Data.data?.principalPaidBuckets} />,
    },
    {
      label: "Gender Analysis",
      key: "3",
      children: <GenderAnalytics data={Data.data?.genderStats} />,
    },
    {
      label: "First Vs Repeat",
      key: "4",
      children: <FirstvsRepeat data={Data.data?.borrowerTypeStats} />,
    },
    {
      label: "Quartile Buckets",
      key: "5",
      children: <QuartileBucket data={Data.data?.quartileBuckets} />,
    },
  ];

  return (
    <div className="mt-1 ">
      <div className="flex justify-end">
        <input style={{border:'1px solid #6f56a3',
          padding:"5px",
          borderRadius:"2px"
        }} type="date"></input>
         <Col className=" pr-3">
          <Button
              type="primary"
              block
              className="pl-1 ml-4 pr-1"
            >
              Search
            </Button>
         </Col>
          
        {/* <Button>Search</Button> */}
            {/* border-color: #6f56a3;
    border: 2px solid #6f56a3;
    padding: 4px;
    border-radius: 10px;
} */}
        {/* <Button
          // loading={info?.file?.status === "uploading"}
          type="primary"
          icon={<UploadOutlined />}
        // disabled={!selectedNBFC}
        >
          Upload Excel
        </Button> */}
        {/* <Select
          defaultValue="All"
          style={{ width: 120 }}
          className=" ml-5"
          // onChange={handleChange}
          options={[
            { value: 'all', label: 'All' },
            { value: 'newCase', label: 'New Case' },
            { value: 'oldCase', label: 'Old Case' },
          ]}
        /> */}
      </div>
      <Tabs items={items}></Tabs>
    </div>
  );
};

export default DailyIntervention;